import { observer } from "mobx-react-lite";
import { Stack, Button, Field, Input } from "@chakra-ui/react";
import { useStores } from "../../../shared/stores/RootStore";
import { CustomDialog } from "../../../shared/views/CustomDialog";
import { Form, Formik } from "formik";
import { toast } from "../../../shared/views/CustomToaster";

const formId = "translateTag";

const TranslateTagDialogBase = ({
  cityId,
  tag,
  onClose,
}: {
  cityId: string;
  tag: { key: string; value: string };
  onClose: () => void;
}) => {
  const { osmToolsStore } = useStores();

  return (
    <Formik
      initialValues={{ key: tag.key, value: tag.value }}
      onSubmit={async (values, { setSubmitting }) => {
        await osmToolsStore.translateTag({
          cityId,
          oldKey: tag.key,
          oldValue: tag.value,
          newKey: values.key,
          newValue: values.value,
        });
        toast("success", "Saved");
        setSubmitting(false);
        onClose();
      }}
      validate={(values) => {
        const errors: Record<string, string> = {};
        if (!values.key) {
          errors.key = "Required";
        }
        if (!values.value) {
          errors.value = "Required";
        }
        return errors;
      }}
    >
      {({ values, handleChange, isSubmitting }) => (
        <CustomDialog
          header={"Translate tag"}
          footer={
            <Button
              type="submit"
              form={formId}
              loading={isSubmitting}
              colorPalette={"primary"}
            >
              Submit
            </Button>
          }
          onClose={onClose}
        >
          <Form id={formId}>
            <Stack gap={4}>
              <Field.Root>
                <Field.Label>Key</Field.Label>
                <Input
                  required
                  name="key"
                  onChange={handleChange}
                  value={values.key}
                  autoFocus
                />
              </Field.Root>

              <Field.Root>
                <Field.Label>Value</Field.Label>
                <Input
                  required
                  name="value"
                  onChange={handleChange}
                  value={values.value}
                />
              </Field.Root>
            </Stack>
          </Form>
        </CustomDialog>
      )}
    </Formik>
  );
};

export const TranslateTagDialog = observer(TranslateTagDialogBase);
